import React, { useState } from 'react';
import DialogModal from '../../../components/DialogModal';
import { StyledButton } from '../../Exams/styled';
import { CircularProgress } from '@mui/material';
import { useSchoolClassesConfigHook } from '../../common/hooks/useSchoolClassesConfig';
import { isEmpty } from 'lodash';
import { SnackbarSeverityType } from '../../../enums';
import paymentConcessionMaster from '../../../apis/payments/paymentConcessionMaster';
import SelectAll from '../../../components/SelectAllField/SelectAllField';

interface AddNewGroupModalProps {
  selectedAcademicYear: string;
  isAddNewGroupModalOpen: boolean;
  allPaymentConcessionMasterGrades: string[];
  setIsAddNewGroupModalOpen: (value: React.SetStateAction<boolean>) => void;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
  fetchPaymentConcessionMaster: () => Promise<void>;
}

const AddNewGroupModal = ({
  selectedAcademicYear,
  isAddNewGroupModalOpen,
  allPaymentConcessionMasterGrades,
  setIsAddNewGroupModalOpen,
  showToast,
  fetchPaymentConcessionMaster
}: AddNewGroupModalProps) => {
  const { gradeOptions, loggedInUser } = useSchoolClassesConfigHook();
  const [grades, setGrades] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddNewGroupModalClose = () => {
    setGrades([]);
    setIsAddNewGroupModalOpen(false);
  };

  const handleSave = async () => {
    setIsSubmitting(true);
    try {
      await paymentConcessionMaster.updatePaymentConcessionMaster({
        school: loggedInUser?.school,
        academicYear: selectedAcademicYear,
        payload: { grades: grades }
      });
      showToast(
        'Successfully updated payment concession grades',
        SnackbarSeverityType.success
      );
      handleAddNewGroupModalClose();
    } catch (error: any) {
      showToast(
        error?.errors?.[0].message ||
          'Error updating payment concession grades',
        SnackbarSeverityType.error
      );
    } finally {
      setIsSubmitting(false);
      fetchPaymentConcessionMaster();
    }
  };

  const filteredGradeOptions = gradeOptions.filter(
    (grade: { label: string; value: string }) =>
      !allPaymentConcessionMasterGrades.includes(grade.value) &&
      !grade.value.includes('-INCOMING')
  );

  return (
    <DialogModal
      title='Add Grades Group'
      open={isAddNewGroupModalOpen}
      onClose={handleAddNewGroupModalClose}
      actions={
        <StyledButton
          onClick={handleSave}
          disabled={isSubmitting || isEmpty(grades)}
        >
          {isSubmitting ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Add'
          )}
        </StyledButton>
      }
    >
      <SelectAll
        label='Grades'
        required
        placeholder='Select Grades'
        onChange={setGrades}
        options={filteredGradeOptions}
        selected={grades}
        hasTopLabel
      />
    </DialogModal>
  );
};

export default AddNewGroupModal;
